jQuery( "body" ).ready( function ( $ ) {
  const all   = ( selector ) => document.querySelector( selector );
  let Step1   = all( "#simul-1" ),
      Step2   = all( "#simul-2" ),
      Step3   = all( "#simul-3" );
  var counter = 1;
  let val     = [],
      data    = [],
      valUSD  = [],
      values  = [],
      p       = {};

  //interact main window
  $( "#go-next" ).click( function () {
    Step1.style.display = "none";
    Step2.style.display = "contents";
  } );

  //hidden select all
  for ( let i = 2; i <= 10; i++ ) {
    all( "#repeat-profiles" + i ).style.display = "none";
  }

  $( ".abc" ).each( function () {
    var nameclass = $( this ).val();
    valUSD.push( parseInt( nameclass ) );
  } );

  $( ".btnHidden" ).click( function () {
    if ( counter > 1 ) {
      let a           = $( this )[ 0 ].parentElement.parentElement.parentElement;
      let b           =
            $( this )[ 0 ].parentElement.parentElement.parentElement.parentElement.parentElement;
      let pp          = $( a ).attr( "class" );
      document.ready  = all( "#options_language" + pp ).value = "";
      document.ready  = all( "#options_year" + pp ).value = "";
      b.style.display = "none";
      counter--;
    }
    if ( counter < 10 ) {
      all( "#add_profiles" ).removeAttribute( "disabled" );
    }
  } );

  //function to add profiles
  all( "#add_profiles" ).addEventListener( "click", ( add_profiles ) => {
    var language   = all( "#options_language" + counter ).value;
    var experience = all( "#options_year" + counter ).value;
    if ( language != "" && experience != "" ) {
      for ( let i = 2; i <= 11; i++ ) {
        let a = all( "#options_language" + i ).value;
        let b = all( "#options_year" + i ).value;

        if ( counter <= 10 && a == "" && b == "" ) {
          all( "#repeat-profiles" + i ).style.display = "flex";
          counter++;
          break;
        }
        if ( counter === 9 ) {
          all( "#add_profiles" ).setAttribute( "disabled", "disabled" );
        } else {
          all( "#add_profiles" ).removeAttribute( "disabled" );
        }
      }
    }
  } );

  $( ".make_simulation" ).click( function ( e ) {
    data.length   = 0;
    values.length = 0;
    capture( e );
  } );

  // this function captures all the data and returns it with a request to page three.
  function capture( e ) {
    e.preventDefault();
    all( "#profileClear" ).style.display = "none";
    for ( let i = 1; i <= counter; i++ ) {
      var language   = all( "#options_language" + [ i ] ).value;
      var experience = all( "#options_year" + [ i ] ).value;

      if ( counter <= 10 && language != "" && experience != "" ) {
        values.push( {
          lenguaje: parseInt( language ),
          experiencia: parseInt( experience ),
        } );
      }
    }
    let modalLenguage   = all( "#options_language" ).value;
    let modalExperience = all( "#options_year" ).value;

    if ( modalExperience != "" && modalLenguage != "" ) {
      values.push( {
        lenguaje: parseInt( modalLenguage ),
        experiencia: parseInt( modalExperience ),
      } );
    }

    jQuery.ajax( {
      type: "POST",
      url: ajax_var.url,
      data: { action: "postType", security: ajax_var.nonce },

      success: function returns( result ) {
        val = JSON.parse( result );
        proceso( val );
      },
    } );
    Step2.style.display = "none";
    Step3.style.display = "contents";
  }

  function proceso( val ) {
    let tax          = parseInt( val[ 0 ][ "Tax" ] );
    let seniority    = [],
        rates_cafeto = [],
        rates_USA    = [],
        a            = [],
        b            = [];
    for ( let i = 0; i < tax; i++ ) {
      seniority.push( val[ 0 ][ "Tax_" + [ i ] + "_seniority" ] );
    }
    for ( let f = 0; f < tax; f++ ) {
      for ( let j = 0; j < 15; j++ ) {
        a[ j ] = parseInt(
          val[ 0 ][ "Tax_" + f + "_experiencescol_" + j + "_experticesCol" ]
        );
        b[ j ] = parseInt(
          val[ 0 ][ "Tax_" + f + "_experiencesUsa_" + j + "_experticesUSA" ]
        );
        rates_cafeto.push( a[ j ] );
        rates_USA.push( b[ j ] );
      }
    }
    p = { seniority, rates_cafeto, rates_USA };
    dataset( values );
  }

  function dataset( values ) {
    data.length          = 0;
    let year;
    let ttmp             = 0,
        tms              = 0,
        tys              = 0,
        usCostTotalTeam  = 0,
        colCostTotalTeam = 0;

    for ( let i = 0; i < values.length; i++ ) {
      let us  = Number(
        valUSD[ ( values[ i ][ "lenguaje" ] - 1 ) * 15 + values[ i ][ "experiencia" ] - 1 ]
      );
      let col = Number(
        p.rates_cafeto[
        ( values[ i ][ "lenguaje" ] - 1 ) * 15 + values[ i ][ "experiencia" ] - 1
          ]
      );

      let hour         = ( col / 160 ).toFixed( 2 );
      let payroll      = us * 0.25;
      let usCost       = us + payroll;
      let usCostTotal  = usCost * 12;
      let mms          = usCost - col;
      let mys          = mms * 12;
      let roi          = ( ( ( usCost - col ) / col ) * 100 );
      usCostTotalTeam  = usCostTotalTeam + usCost;
      colCostTotalTeam = colCostTotalTeam + col;
      ttmp             = ttmp + col;
      tms              = tms + mms;
      tys              = tys + mys;

      if ( values[ i ][ "experiencia" ] != 1 ) {
        year = values[ i ][ "experiencia" ] + "  Years";
      } else {
        year = values[ i ][ "experiencia" ] + "  Year";
      }
      data.push( {
        id: i,
        experticesNumber: values[ i ][ "experiencia" ],
        branch: values[ i ][ "lenguaje" ],
        Profile: i + 1,
        Language: p.seniority[ values[ i ][ "lenguaje" ] - 1 ],
        Experience: year,
        Rate_cafeto: col,
        hours: hour,
        US_Salary: us,
        payroll: payroll,
        usCost: usCost,
        usCostTotalYear: usCostTotal,
        minimum_M: mms,
        minimum_Y: mys,
        ttmpi: ttmp,
        tmsi: tms,
        tysi: tys,
        singleRoi: roi,
      } );
    }

    let usCostTotalTeamRoi = usCostTotalTeam * 12;
    colCostTotalTeam       = colCostTotalTeam * 12;

    let roiTotalTeam = ( ( ( usCostTotalTeamRoi - colCostTotalTeam ) / colCostTotalTeam ) * 100 );

    addhtml( data, usCostTotalTeam, roiTotalTeam );
  }

  // read data and insert it into HTML
  function addhtml( data, usCostTotalTeam, roiTotalTeam ) {
    let result              = all( "#profiles" );
    result.innerHTML        = "";
    let total               = all( "#totalM" );
    total.innerHTML         = "";
    let prueba              = all( ".acum" );
    prueba.innerHTML        = "";
    let num                 = new Intl.NumberFormat( 'es-MX' );
    let usCostTotalTeamYear = usCostTotalTeam * 12;

    if ( data.length == 1 ) {
      all( "#totalM" ).style.display     = "flex";
      all( ".hid" ).style.display        = "contents";
      all( ".hidd" ).style.display       = "none";
      all( "#acum" ).style.display       = "none";
      all( ".make-simul" ).style.display = "none";

      for ( let i = 0; i < data.length; i++ ) {
        result.innerHTML +=
          `
          <li style="flex-flow: column wrap; justify-content: normal !important;" class="task-delete">
          <p style="font-size:21px; width:80%;"><strong>Profile: ${ data[ i ].Language }</strong></p>
          <p style="font-size:21px;"><strong>Experience: ${ data[ i ].Experience }</strong></p>
          <p>Average 2022 US Salary (Glassdoor) <strong>$${ num.format( data[ i ].US_Salary ) }</strong></p>
          <p>Payroll Cost (IRS) <strong>$${ num.format( data[ i ].payroll ) }</strong></p>
          <p>Total Monthly US Cost <strong>$${ num.format( data[ i ].usCost ) }</strong></p>
          </li>
        `;

        total.innerHTML +=
          `
          <div class="acum">
					<h3><strong>Total Yearly US Price</strong></h3>
					<h2><strong>$${ num.format( data[ i ].usCostTotalYear ) }</strong></h2>
				  </div>
				  <div class="minimumYearly">
					<h3><strong>Total Monthly US Price</strong></h3>
          <h2><strong>$${ num.format( data[ i ].usCost ) }</strong></h2>
				  </div>
        `;

        $( ".cafeto-rate" ).click( function () {
          all( ".hidd" ).style.display       = "none";
          all( ".hid" ).style.display        = "none";
          all( ".make-simul" ).style.display = "contents";
          result.innerHTML                   = "";
          total.innerHTML                    = "";

          result.innerHTML +=
            `
            <li style="flex-flow: column wrap;" class="task-delete">
            <p style="font-size:21px;"><strong>Cafeto Rate</strong></p>
            <p style="font-size:21px; width:80%;"><strong>Profile: ${ data[ i ].Language }</strong></p>
            <p style="font-size:21px;"><strong>Experience: ${ data[ i ].Experience }</strong></p>
            <h2><strong>$${ num.format( data[ i ].Rate_cafeto ) } ($${ data[ i ].hours } hourly)</strong></h2>
            <p>Average 2022 US Salary (Glassdoor) <strong>$${ num.format( data[ i ].US_Salary ) }</strong></p>
            <p>Payroll Cost (IRS) <strong>$${ num.format( data[ i ].payroll ) }</strong></p>
            <p><strong>Position ROI ${ num.format( data[ i ].singleRoi.toFixed( 1 ) ) }%</strong></p>
            </li>
          `;
          total.innerHTML +=
            `
            <div class="acum">
            <h3><strong>Minimum Monthly Savings</strong></h3>
            <h2><strong>$${ num.format( data[ i ].minimum_M ) }</strong></h2>
            </div>
            <div class="minimumYearly">
            <h3><strong>Minimum Yearly Savings</strong></h3>
            <h2><strong>$${ num.format( data[ i ].minimum_Y ) }</strong></h2>
            </div>
          `;

          return result, total;
        } );
      }
    } else if ( data.length > 1 ) {
      all( "#totalM" ).style.display     = "flex";
      all( ".hid" ).style.display        = "none";
      all( ".hidd" ).style.display       = "contents";
      all( "#acum" ).style.display       = "none";
      all( ".make-simul" ).style.display = "none";

      for ( let i = 0; i < data.length; i++ ) {
        result.innerHTML +=
          `
          <li style="flex-flow: row wrap;" taskId=${ data[ i ].id } taskL=${ data[ i ].branch } taskY=${ data[ i ].experticesNumber }>
          <div class="oji1">
          <button class="task-delete btn">X</button>
          </div>
          <div class="mb-3 w-75">
          <p style="font-size:22px;"><strong>${ data[ i ].Language }</strong></p>
          <p style="font-size:22px;"><strong>${ data[ i ].Experience } of experience</strong></p>
          <p>Average 2022 US Salary (Glassdoor) <strong>$${ num.format( data[ i ].US_Salary ) }</strong></p>
          <p>Payroll Cost (IRS) <strong>$${ num.format( data[ i ].payroll ) }</strong></p>
          <p>Total Monthly US Cost <strong>$${ num.format( data[ i ].usCost ) }</strong></p>
          </div>
          </li>
        `;

        $( ".cafeto-rate" ).click( function () {
          result.innerHTML                   = "";
          all( ".hidd" ).style.display       = "none";
          all( ".make-simul" ).style.display = "contents";

          for ( let i = 0; i < data.length; i++ ) {
            result.innerHTML +=
              `
              <li style="flex-flow: row wrap;" taskId=${ data[ i ].id } taskL=${ data[ i ].branch } taskY=${ data[ i ].experticesNumber }>
              <div class="oji1">
              <button class="task-delete btn">X</button>
              </div>
              <div class="mb-3 w-75">
              <p style="font-size:22px;"><strong>${ data[ i ].Language }</strong></p>
              <p style="font-size:22px;"><strong>${ data[ i ].Experience } of experience</strong></p>
              <h3>$${ num.format( data[ i ].Rate_cafeto ) } ($${ data[ i ].hours } hourly)</h3>
              <p>Average 2022 US Salary (Glassdoor) $${ num.format( data[ i ].US_Salary ) }</p>
              <p>Payroll Cost (IRS) $${ num.format( data[ i ].payroll ) }</p>
              <p>Total Monthly US Cost $${ num.format( data[ i ].usCost ) }</p>
              <p><strong>Position ROI ${ num.format( data[ i ].singleRoi.toFixed( 1 ) ) }%</strong></p>
              <p><strong>Minimum Monthly Savings $${ num.format( data[ i ].minimum_M ) }</strong></p>
              <p><strong>Minimum Yearly Savings $${ num.format( data[ i ].minimum_Y ) }</strong></p>
              </div>
              </li>
            `;
          }

          return result[ i ];
        } );
      }

      for ( let i = 0; i < 1; i++ ) {
        total.innerHTML +=
          `
          <div class="acum">
					<h3><strong>Total Team Yearly US Price</strong></h3>
					<h2 id="ttmp"><strong>$${ num.format( usCostTotalTeamYear ) }</strong></h2>
          </div>
          <div class="minimumMonthly">
          <h3><strong>Total Team Monthly US Price</strong></h3>
          <h2 id="mms"><strong>$${ num.format( usCostTotalTeam ) }</strong></h2>
          </div>
        `;

        $( ".cafeto-rate" ).click( function () {
          total.innerHTML = "";

          for ( let i = 0; i < 1; i++ ) {
            total.innerHTML +=
              `
              <div class="acum">
              <h3><strong>Total Team Monthly Price</strong></h3>
              <h2 id="ttmp"><strong>$${ num.format( data[ data.length - 1 ].ttmpi ) }</strong></h2>
              </div>
              <div class="minimumMonthly">
              <h3><strong>Minimum Monthly Savings</strong></h3>
              <h2 id="mms"><strong>$${ num.format( data[ data.length - 1 ].tmsi ) }</strong></h2>
              </div>
              <div class="minimumYearly">
              <h3><strong>Minimum Yearly Savings</strong></h3>
              <h2 id="mys"><strong>$${ num.format( data[ data.length - 1 ].tysi ) }</strong></h2>
              </div>
              <div class="minimumYearly">
              <h3><strong>Total Team ROI</strong></h3>
              <h2 id="mys"><strong>${ roiTotalTeam.toFixed( 1 ) }%</strong></h2>
              </div>
            `;
          }

          return total;
        } );
      }
    } else if ( data.length == 0 ) {
      all( "#profileClear" ).style.display = "flex";
      all( "#acum" ).style.display         = "flex";
      all( ".hid" ).style.display          = "none";
      all( ".hidd" ).style.display         = "contents";
    }

    remove( data );
  }

  // remove unwanted profile
  function remove( data ) {
    if ( all( ".task-delete" ) ) {
      $( ".task-delete" ).click( function () {
        let element = $( this )[ 0 ].parentElement.parentElement;
        let atr     = $( element ).attr( "taskL" );
        let exp     = $( element ).attr( "taskY" );
        let id      = $( element ).attr( "taskId" );

        for ( let i = 1; i <= 10; i++ ) {
          let a = all( "#options_language" + [ i ] ).value,
              b = all( "#options_year" + [ i ] ).value;
          let c = all( "#options_language" ).value,
              d = all( "#options_year" ).value;

          if ( atr === a && exp === b ) {
            document.ready = all( "#options_language" + [ i ] ).value = "";
            document.ready = all( "#options_year" + [ i ] ).value = "";
            values.splice( id, 1 );
            dataset( values );
            break;
          } else if ( atr === c && exp === d ) {
            document.ready = all( "#options_language" ).value = "";
            document.ready = all( "#options_year" ).value = "";
            values.splice( id, 1 );
            dataset( values );
            break;
          }
        }
      } );
    } else {
      all( "#profileClear" ).style.display = "flex";
    }
  }

  //clear page 3
  all( "#clear" ).addEventListener( "click", ( e ) => {
    e.preventDefault();
    values.length                  = 0;
    data.length                    = 0;
    document.ready                 = all( "#options_language" ).value = "";
    document.ready                 = all( "#options_year" ).value = "";
    all( "#totalM" ).style.display = "none";

    for ( let i = 1; i <= 10; i++ ) {
      document.ready = all( "#options_language" + [ i ] ).value = "";
      document.ready = all( "#options_year" + [ i ] ).value = "";
    }

    for ( let i = 2; i <= 10 - 1; i++ ) {
      all( "#repeat-profiles" + i ).style.display = "none";
    }
    capture( e );
    all( "#profileClear" ).style.display = "flex";
  } );

  // Reset all values in Step2
  $( ".return" ).click( function ( e ) {
    e.preventDefault();

    document.ready = all( "#options_language" ).value = "";
    document.ready = all( "#options_year" ).value = "";

    for ( let i = 1; i <= 10; i++ ) {
      document.ready = all( "#options_language" + [ i ] ).value = "";
      document.ready = all( "#options_year" + [ i ] ).value = "";
    }

    for ( let i = 2; i <= 11 - 1; i++ ) {
      all( "#repeat-profiles" + i ).style.display = "none";
    }
    Step2.style.display = "contents";
    Step3.style.display = "none";
    Step1.style.display = "none";
    counter             = 1;
    all( "#add_profiles" ).removeAttribute( "disabled" );
    all( "#profileClear" ).style.display = "none";

    values.length = 0;
  } );
} );
